import { atom } from 'recoil';

import { ITakeNodeModal } from '@/components/PdfReader';

export const takeNoteModalAtom = atom<ITakeNodeModal>({
  key: 'takeNoteModalAtom',
  default: {
    value: false,
    pageNumber: 0,
    selectedText: '',
    selectionRect: null,
    noteId: undefined,
  },
});
